import React, { ReactNode } from "react"

import { OverlayStyle } from "shared/context/overlay/types"
import { OverlayHeader } from "shared/ui/overlay/OverlayHeader"
import { OverlayWrapper } from "shared/ui/overlay/OverlayWrapper"

export interface DataTableOverlayViewProps {
  headline: string
  children: ReactNode
  onClose: () => void
}

export const ContentOverlayView = React.memo(
  ({ headline, children, onClose }: DataTableOverlayViewProps) => (
    <OverlayWrapper id="content-overlay" overlayStyle={OverlayStyle.CONTENT}>
      <OverlayHeader.Container responsive={false}>
        <OverlayHeader.Title>{headline}</OverlayHeader.Title>
        <OverlayHeader.CloseButton onClick={onClose} />
      </OverlayHeader.Container>
      <div className="content-overlay__body">{children}</div>
    </OverlayWrapper>
  )
)
